import { isActive } from '@tiptap/core';
import classNames from 'classnames';
import Button from 'components/ui-new/Button';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { Dispatch, FC, SetStateAction } from 'react';
import { ProductType } from 'types/enums';
import { getCountedItemKey } from 'utils/getCountedItemKey';
import { TariffCard } from '..';
import { ShopPages } from '../../..';
import styles from './style.module.scss';

interface Props {
  setIsShowAddInfo: Dispatch<SetStateAction<boolean>>;
  doAFlip: () => void;
  type: ProductType;
}

type PickedProps = Pick<TariffCard, 'setPage'>;

const AddInfo: FC<Props & PickedProps> = ({ setPage, setIsShowAddInfo, doAFlip, type }) => {
  const t = useTranslations();

  const handleClickBack = () => {
    setIsShowAddInfo(false);
    doAFlip();
  };

  const handleClickSeeTariffs = () => {
    setPage(ShopPages.AllOffers);
  };

  return (
    <div
      className={classNames(styles.addInfo, {
        [styles.addInfo__disabled]: isActive,
      })}>
      <Image
        className={styles.addInfo__iconArrow}
        src='/icons/arrow-left.svg'
        width={24}
        height={24}
        alt='arrow left'
        onClick={handleClickBack}
      />
      <Image
        className={styles.addInfo__iconInfo}
        src='/icons/info-orange.svg'
        width={18}
        height={18}
        alt='info orange'
      />
      <div>
        <div
          className={
            styles.addInfo__title
          }>{`${t('shop_leave')} ${t(getCountedItemKey(type), { count: 1 })}`}</div>
        <p className={styles.addInfo__desc}>{t('placement_is_hired')}</p>
        <Button onClick={handleClickSeeTariffs} className={styles.addInfo__btn}>
          {t('choose_tariff')}
        </Button>
      </div>
    </div>
  );
};

export default AddInfo;
